var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(_vm.permissionsReady)?_c('dynameat-header'):_vm._e(),_c('v-main',[(_vm.permissionsReady)?_c('router-view'):_vm._e(),_c('dynameat-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }